import AuthApp from "@/components/auth/AuthApp.vue";
import { bus } from "@/components/input/bus.js";
import createApp from '@/shared/create-vuetify-app';

class AuthPopupHandler
{
    app;

    _initApp(nextUrl, skipCaptcha)
    {
        if (!this.app) {
            this.app = createApp(AuthApp, '#authApp', {
                next: nextUrl,
                skipCaptcha: skipCaptcha,
            });
        }

        return this.app;
    }

    showLoginPopup(nextUrl, skipCaptcha)
    {
        this._initApp(nextUrl, skipCaptcha);
        bus.emit('openLoginDialog');
    }

    showSignupPopup(nextUrl, skipCaptcha)
    {
        this._initApp(nextUrl, skipCaptcha);
        bus.emit('openSignupDialog');
    }
}

const authPopupHandler = new AuthPopupHandler();

export default authPopupHandler;
